import { render, staticRenderFns } from "./aldehyd-nachweis.vue?vue&type=template&id=157dc066&"
import script from "./aldehyd-nachweis.vue?vue&type=script&lang=js&"
export * from "./aldehyd-nachweis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports